<template>
  <div class="wrapper z-20" ref="wrapper">
    <transition-group name="slide">
      <header-notification-body
        v-for="notification in notifications"
        :key="notification.id"
        :notification="notification"
        class="note fixed flex bg-purple-500 p-4 "
        :style="{ width: panelWidth + 'px' }"
      >
      </header-notification-body>
    </transition-group>
  </div>
</template>

<script>
import HeaderNotificationBody from "@/components/HeaderNotificationBody.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    HeaderNotificationBody,
  },
  computed: {
    ...mapState("notification", ["notifications"]),
    
  },
  methods: {
    ...mapActions("notification", ["remove"]),
    updatePanelWidth(){
      this.panelWidth = this.$refs.wrapper.offsetWidth;
    }
  },
  props: {},
  data() {
    return {
      panelWidth: 1030,
    };
  },
  mounted() {
    this.$nextTick(function() {     
            //Sync height of overlay to height of phrase when view is intially rendered and on window resize
            this.updatePanelWidth();
            window.addEventListener("resize", this.updatePanelWidth);
    }); 
  },
  destroyed(){
    window.removeEventListener("resize", this.updatePanelWidth);
  }
};
</script>

<style scoped>
.wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
.note {
  text-align: center;
  overflow: hidden;
  -webkit-box-shadow: 4px -1px 4px 2px #a5a1a1;
  -moz-box-shadow: 4px -1px 4px 2px #a5a1a1;
  box-shadow: 4px -1px 4px 2px #a5a1a1;
}
.slide-enter-active {
  transition: 0.5s linear;
}
.slide-leave-active {
  transition: 0.3s ease-in;
}
.slide-enter {
  transform: translate(0, -50px);
}
.slide-leave-to {
  transform: translate(0, -100%);
}
</style>
